<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>{{ $lang.comboOffer.title }}</strong>
            </CCol>
            <CCol sm="6" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">
                <!--<CButton color="primary" v-on:click="createTableRow" v-if='checkPermission("create-combo-offer")' style="margin-right: 10px;">{{ $lang.buttons.general.crud.create }} </CButton>-->
                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton
                      color="danger"
                      v-c-tooltip="$lang.buttons.export.pdf"
                      v-on:click="exports(self, 'pdf', module, 'Combo Offer',self.userId)"
                  >
                    <i class="fas fa-file-pdf"></i>
                  </CButton>
                  <VueJsonToCsv
                      class="btn btn-success"
                      v-c-tooltip="$lang.buttons.export.excel"
                      :json-data="json_data"
                      :labels="json_label"
                      :csv-title="json_title"
                  >
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
                <BeforeFilter
                    :filterShow="toggleFilterValue"
                    @getFilterToggle="switchFilter"
                ></BeforeFilter>
              </div>
            </CCol>
          </div>
        </CCardHeader>
        <CCardBody>
          <transition name="fade">
            <CRow v-if="toggleFilterValue">
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{
                      $lang.comboOffer.filter.startDate
                    }}</label>
                  <input
                      type="date"
                      :placeholder="$lang.comboOffer.filter.startDate"
                      class="form-control"
                      v-model="comboOffer.startDate"
                  />
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{
                      $lang.comboOffer.filter.endDate
                    }}</label>
                  <input
                      type="date"
                      :placeholder="$lang.comboOffer.filter.endDate"
                      class="form-control"
                      v-model="comboOffer.endDate"
                  />
                </div>
              </CCol>
              <CCol sm="3" v-show="!iAmUser">
                <div class="form-group">
                  <label class="form__label">{{
                      $lang.comboOffer.filter.profileVerified
                    }}</label>
                  <v-select
                      :options="profileVerifiedOptions"
                      v-model="comboOffer.profileVerified"
                  ></v-select>
                </div>
              </CCol>
              
              <CCol sm="3" v-show="!iAmUser">
                <div class="form-group">
                  <label class="form__label">{{
                      $lang.comboOffer.filter.user
                    }}</label>
                  <v-select
                      :options="userOptions"
                      v-model="comboOffer.user"
                  ></v-select>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">Status</label>
                  <v-select
                      :options="statusOptions"
                      v-model="comboOffer.status"
                  ></v-select>
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group" style="margin-top: 30px">
                  <CButton
                      type="submit"
                      size="sm"
                      color="primary"
                      @click="applyFilter()"
                      v-c-tooltip="$lang.common.filter.button.filter"
                  >
                    {{ $lang.common.filter.button.filter }}
                  </CButton>
                  &nbsp;
                  <CButton
                      color="danger"
                      size="sm"
                      @click="resetFilter()"
                      v-c-tooltip="$lang.common.filter.button.cancel"
                  >
                    {{ $lang.common.filter.button.cancel }}
                  </CButton>
                </div>
              </CCol>
            </CRow>
          </transition>
          <CAlert
              :color="messageColor"
              closeButton
              :show.sync="dismissCountDownS"
              fade
          >{{ alertMessage }}
          </CAlert
          >
          <v-server-table
              :columns="columns"
              :url="listUrl"
              :options="options"
              ref="myTable"
              @loaded="exports(self, 'Excel', module, 'Combo Offer',self.userId)"
          >
            <template #status="data">
              <span v-if="data.row.status == '1'">
                <CBadge :color="statusBudget(data.row.status)">Open</CBadge>
              </span>
              <span v-if="data.row.status == '0'">
                <CBadge :color="statusBudget(data.row.status)">Pending For Publish</CBadge>
              </span>
              <span v-if="data.row.status == '2'">
                <CBadge :color="statusBudget(data.row.status)">Closed</CBadge>
              </span>
              <span v-if="data.row.status == '3'">
                <CBadge :color="statusBudget(data.row.status)">Blocked</CBadge>
              </span>
              <span v-if="data.row.status == '4'">
                <CBadge :color="statusBudget(data.row.status)">Blocked</CBadge>
              </span>
            </template>
            <template #name="data">
              <span :title="data.row.name">{{
                  trimfunction(data.row.name, 75)
                }}</span>
            </template>
            <template #userWithCompany="data">
              <Avatar
                  :image="data.row.avatar"
                  :defaultImage="data.row.avatar"
                  :content="data.row.userWithCompany"
                  :length="20"
              />
            </template>
            <template #updatedAt="data">
              {{ dateTimeUTCtoLocalFormat(data.row.updatedAt) }}
            </template>

            <template #actions="data">
              <CButton
                  color="primary"
                  v-c-tooltip="$lang.buttons.general.crud.view"
                  v-on:click="editTableRow(data.row.id, data.row.userId)"
              >
                <i class="fas fa-eye"></i>
              </CButton>
              <CButton
                  color="danger"
                  v-c-tooltip="$lang.buttons.general.crud.delete"
                  v-on:click="deletePopup(data.row.id)"
              >
                <i class="fas fa-trash"></i>
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {
  comboOffer,
  industry,
  resourcetype,
  duration,
  currencytype,
  priority,
  users,
  skills,
} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import "vue-simple-range-slider/dist/vueSimpleRangeSlider.css";
import BeforeFilter from "../BeforeFilterOpen";
import VueJsonToCsv from "vue-json-to-csv";
import Avatar from "/src/components/Avatar";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
  name: "ComboOffer",
  mixins: [Mixin],
  components: {
    BeforeFilter,
    VueJsonToCsv,
    Avatar,
  },
  data() {
    return {
      iAmUser: "",
      messageColor: "success",
      json_data: [],
      json_label: {},
      json_title: "",
      toggleFilterValue: false,
      range: [0, 1000000],
      number: 1,
      err_msg: "",
      largeModal: false,
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      msg: "",
      items: [],
      industryOptions: [],
      subIndustryOptions: [],
      resourceTypeOptions: [],
      currencyOptions: [],
      visibilityOptions: [
        {
          value: 1,
          label: "Local",
        },
        {
          value: 2,
          label: "National",
        },
        {
          value: 3,
          label: "International",
        },
      ],
      durationOptions: [],
      priorityOptions: [],
      workTypeOptions: [],
      statusOptions:[],
      skillsOptions: [],
      selectedSkills: [],
      userOptions: [],
      remoteWorkOptions: [],
      profileVerifiedOptions: [],
      activePage: 1,
      module: comboOffer,
      moduleIndustry: industry,
      moduleResource: resourcetype,
      moduleDuration: duration,
      moduleCurrency: currencytype,
      modulePriority: priority,
      moduleSkills: skills,
      moduleUser: users,
      comboOffer: {
        name: "",
        budget: "",
        isActive: "",
      },
      columns: [
        "userWithCompany",
        "title",
        "updatedAt",
        "actions",
      ],
      data: [],
      options: {
        headings: {
          userWithCompany: this.$lang.post.table.userName,
          ratingLabel: this.$lang.comboOffer.table.information,
          name: this.$lang.comboOffer.table.name,
          visibility: this.$lang.comboOffer.table.visibility,
          status: this.$lang.comboOffer.table.status,
          updatedAt: this.$lang.common.table.updatedAt,
          actions: this.$lang.common.general.actions,
        },
        editableColumns: [
          "company",
          "status",
        ],
        sortable: [
          "company",
          "name",
          "ratingLabel",
          "status",
        ],
        filterable: [
          "company",
          "name",
          "status",
          "actions",
        ],
      },
    };
  },

  created() {
    let self = this;
    self.listUrl = "/combo-offers/list";
    self.userId = this.$route.params.user_id;
    if (typeof self.userId !== "undefined" || self.userId != null) {
      self.listUrl = this.listUrl +'/' +self.userId;
    } else {
      self.listUrl = this.listUrl;
    }
  },

  mounted() {
    let self = this;
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;

    self.iAmUser = localStorage.getItem("iAmUser"); //hide some filter information.

    store.commit("showLoader", true); //Loading Image
    self.profileVerifiedOptions.push(
        {value: "1", label: "Pending"},
        {value: "2", label: "Verified"},
        {value: "3", label: "Blocked"}
    );
    self.statusOptions.push(
        {value: "1", label: "Open"},
        {value: "3", label: "Closed"},
        {value: "4", label: "Draft"},
        {value: "0", label: "New"}
    );
    self.remoteWorkOptions.push(
        {value: "Yes", label: "Yes"},
        {value: "No", label: "No"}
    );
    axios.get(this.listUrlApi(this.moduleIndustry)).then((response) => {
      response.data.data.map(function (value, key) {
        if (value.industryId === "") {
          self.industryOptions.push({value: value.id, label: value.industry});
        }
      });
    });
    axios.get(this.listUrlApi(this.moduleDuration)).then((response) => {
      response.data.data.map(function (value, key) {
        self.durationOptions.push({value: value.id, label: value.title});
      });
    });
    axios.get(this.listUrlApi(this.moduleSkills)).then((response) => {
      response.data.data.map(function (value, key) {
        self.skillsOptions.push({value: value.id, label: value.title});
      });
    });
    
    axios.get(this.listUrlApi(this.moduleUser)).then((response) => {
      response.data.data.map(function (value, key) {
        self.userOptions.push({value: value.id, label: value.name});
      });
    });
    if (localStorage.getItem("showAlert") !== "") {
      this.setAlert(true);
    }
    this.setAlert(false);
    localStorage.setItem("showAlert", "");

    var filterDetail = JSON.parse(localStorage.getItem("Combo Offer"));
    if(filterDetail && filterDetail.hasOwnProperty('startDate')) {
      self.comboOffer.startDate = filterDetail.startDate;
      self.comboOffer.endDate = filterDetail.endDate;
      var val = "";
      if(filterDetail.status == "Open") {
        val = "1";
      }
      if(filterDetail.status == "New") {
        val = "0";
      }
      if(filterDetail.status == "Closed") {
        val = "4";
      }
      if(filterDetail.status == "Draft") {
        val = "3";
      }
      if(val != "") {
        self.comboOffer.status = {value: val, label: filterDetail.status};
      }
      self.applyFilter();
      localStorage.setItem("Combo Offer",null);
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    switchFilter(show) {
      this.toggleFilterValue = show;
    },
    candidateList(row) {
      this.$router.push({path: `/combo-offers/candidates/${row.id}`});
    },
    getSubIndustry() {
      let self = this;
      if (self.comboOffer.industry.value > 0) {
        const postData = {industry_id: self.comboOffer.industry.value};
        axios
            .post(this.listUrlApi(this.moduleIndustry), postData)
            .then((response) => {
              self.subIndustryOptions = [];
              response.data.data.map(function (value, key) {
                if (value.industryId > 0) {
                  self.subIndustryOptions.push({
                    value: value.id,
                    label: value.SubIndustry,
                  });
                }
              });
            });
      }
    },
    applyFilter() {
      let self = this;
      let postTypeId = "";
      let industry = "";
      let subIndustry = "";
      let duration = "";
      let priority = "";
      let profileVerified = "";
      let currency = "";
      let visibility = "";
      let remoteWork = "";
      let skills = "";
      let user = "";
      let status = "";
      self.selectedSkills = [];
      if (this.comboOffer.postTypeId != null) {
        postTypeId = this.comboOffer.postTypeId.value;
      }
      if (this.comboOffer.industry != null) {
        industry = this.comboOffer.industry.value;
      }
      if (this.comboOffer.subIndustry != null) {
        subIndustry = this.comboOffer.subIndustry.value;
      }
      if (this.comboOffer.resourceType != null) {
        resourceType = this.comboOffer.resourceType.value;
      }
      if (this.comboOffer.duration != null) {
        duration = this.comboOffer.duration.value;
      }
      if (this.comboOffer.priority != null) {
        priority = this.comboOffer.priority.value;
      }
      if (this.comboOffer.status != null) {
        status = this.comboOffer.status.value;
      }
      if (this.comboOffer.profileVerified != null) {
        profileVerified = this.comboOffer.profileVerified.value;
      }
      if (this.comboOffer.currency != null) {
        currency = this.comboOffer.currency.value;
      }
      if (this.comboOffer.visibility != null) {
        visibility = this.comboOffer.visibility.value;
      }
      if (this.comboOffer.remoteWork != null) {
        remoteWork = this.comboOffer.remoteWork.value;
      }
      if (this.comboOffer.user != null) {
        user = this.comboOffer.user.value;
      }
      if (this.comboOffer.skills != null) {
        skills = this.comboOffer.skills;
        skills.map(function (value, key) {
          self.selectedSkills.push({
            value: value.value,
          });
        });
      }

      const reqObj = {
        postType: postTypeId,
        industry: industry,
        subIndustry: subIndustry,
        // resourceType: resourceType,
        duration: duration,
        priority: priority,
        profileVerified: profileVerified,
        currency: currency,
        visibility: visibility,
        remoteWork: remoteWork,
        user: user,
        status: status,
        fromDate: self.comboOffer.startDate,
        toDate: self.comboOffer.endDate,
        range: this.range,
      };
      store.commit("showLoader", true);
      this.$refs.myTable.customQueries = reqObj;
      this.$refs.myTable.refresh();
    },

    resetFilter() {
      this.comboOffer.postTypeId = {};
      this.comboOffer.industry = {};
      this.comboOffer.subIndustry = {};
      this.comboOffer.duration = {};
      this.comboOffer.priority = {};
      this.comboOffer.profileVerified = {};
      this.comboOffer.currency = {};
      this.comboOffer.visibility = {};
      this.comboOffer.remoteWork = {};
      this.comboOffer.user = {};
      this.comboOffer.startDate = {};
      this.comboOffer.endDate = {};
      this.comboOffer.status = {};
      this.range = [0, 1000000];
      store.commit("showLoader", true);
      this.$refs.myTable.customQueries = {};
      this.$refs.myTable.refresh();
    },
    setAlert(value) {
      this.showAlert = value;
    },
    deletePopup(item) {
      this.$swal({
        title: this.$lang.common.delete_swal.are_you,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e55353",
        confirmButtonText: this.$lang.common.delete_swal.yes_delete,
        cancelButtonText: this.$lang.common.delete_swal.cancel,
      }).then((result) => {
        // <--
        if (result.value) {
          // <-- if accepted
          let self = this;
          axios
              .delete(this.deleteUrlWeb(this.module, item), self)
              .then(function (response) {
                if (response.status === 200) {
                  self.$refs.myTable.refresh();
                  self.alertMessage = response.data.message;
                  self.messageColor = "success";
                  self.dismissCountDownS = 10;
                } else {
                  self.$refs.myTable.refresh();
                  self.alertMessage = response.data.message;
                  self.messageColor = "danger";
                  self.dismissCountDownS = 10;
                }
              }).catch(function (error) {
            let data;
            if (error.response.data.error) {
              data = error.response.data.error.toString();
            } else {
              data = error.response.data.message;
            }
            self.alertMessage = data;
            self.messageColor = "danger";
            self.dismissCountDownS = 10;
          });
        }
      });
    },
    createTableRow() {
      this.$router.push({name: "Combo Offer Create"});
    },
    editTableRow(item, userId) {
      this.$router.push({path: `combo-offers/view/${item}/${userId}`});
    },
    viewMediaTableRow(item, userId) {
      this.$router.push({path: `combo-offers/media/list/${item}`});
    },
    viewResponseTableRow(item) {
      this.$router.push({path: `combo-offers/response/list/${item}`});
    },
    viewReportTableRow(item) {
      this.$router.push({path: `combo-offers/report/list/${item}`});
    },
    rowClicked(item) {
      this.$router.push({path: `country/view/${item}`});
    },
    pageChange(val) {
      this.$router.push({query: {page: val}});
    },
    loadData() {
      let self = this;
      axios
          .get(this.listUrlApi(this.module), self.model)
          .then(function (response) {
            if (response) {
              self.data = response.data;
            } else {
              self.data = [];
            }
            store.commit("showLoader", false);
          })
          .catch(function (error) {
            store.commit("showLoader", false);
          });
    },
  },
};
</script>
